import React from 'react';
import styled from 'styled-components';
import { A, Small } from '@upsolve/ui';

import upsolveStats from '../../../content/onBuild/upsolveStats.json';
import IconPiggyBank from '../../../static/images/icon-piggy-bank.svg';
import IconClockFast from '../../../static/images/icon-clock-fast.svg';
import IconHeartHand from '../../../static/images/icon-heart-hand.svg';

import { ButtonLink } from '../Inputs/Button.span';

const HeroFilerCta = () => (
  <HeroFilerCtaWrapper>
    <div className="headline">
      A nonprofit that helps you file bankruptcy for free.
    </div>
    <div className="value-props">
      <ul>
        <li>
          <IconPiggyBank /> <span>We've helped over 2,000 families each <b>clear on average ${upsolveStats.debtCleared.averagePerFiler.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} of debt</b>.</span>
        </li>
        <li>
          <IconClockFast /> <span>Our users often file within 10 days of starting.</span>
        </li>
        <li>
          <IconHeartHand /> <span>Our <b>award winning nonprofit's</b> help is 100% free.</span>
        </li>
      </ul>
    </div>
    <div className="action">
      <ButtonLink aria-busy="false" size="lg" href="https://my.upsolve.org/screener">Get Started</ButtonLink>
    </div>
    <br />
  </HeroFilerCtaWrapper>
);

const HeroFilerCtaWrapper = styled.div`
  max-width: 600px;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.1);
  padding: 3em;
  background: ${props => props.theme.colors.white['900']};
  div.headline {
    color: ${props => props.theme.colors.black['100']};
    font-size: 28px;
    font-weight: 500;
    line-height: 130%;
  }
  div.value-props {
    ul, ol, li {
      padding-left: 0;
      padding-right: 0;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 0;
    }
    li {
      display: flex;
      align-items: center;
      margin-bottom: 1.25em;
      line-height: 120%;
      font-size: 15px;
    }
    svg {
      height: 28px;
      width: 28px;
      min-height: 28px;
      min-width: 28px;
      max-height: 28px;
      max-width: 28px;
      margin-right: 0.75em;
      &, path {
        fill: ${props => props.theme.colors.orange['500']};
      }
    }
    path {
      fill: ${props => props.theme.colors.brand['500']};
    }
  }
  div.action {
    display: flex;
    justify-content: center;
    a, a:hover {
      background: linear-gradient(270deg,#ff863b -65.78%, #f66161 45.1%);
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
      border: none;
      border-bottom: 4px solid #d13f3f;
      border-radius: 6px;
      margin: 0.5em 0 0;
      width: 100%;
    }
  }

  @media (max-width: 45em) {
    padding: 2em;
    margin-left: -1.5em;
    margin-right: -1.5em;
    box-shadow: 0 0 15px -5px rgba(0, 0, 0, 0.15);
    div.headline {
      font-size: 24px;
    }
  }
`;

export default HeroFilerCta;
